import React, { useEffect, useState } from 'react';
import { useForm, ValidationError } from '@formspree/react';
import { Toaster, toast } from 'react-hot-toast';
import { FaCheckCircle } from 'react-icons/fa';
import { ImSpinner2 } from 'react-icons/im';

const Contact = () => {
  const [state, handleSubmit] = useForm("mgvweqgn");
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    if (state.succeeded) {
      setIsSuccess(true);
      toast.success("Message sent successfully!", {
        style: {
          background: '#1f2937', // gray-800
          color: '#fff',
          border: '1px solid #374151',
        },
        iconTheme: {
          primary: '#22c55e',
          secondary: '#1f2937',
        },
      });
    }
  }, [state.succeeded]);

  return (
    <section id="contact" className="mt-20 pt-12 pb-16 px-4 min-h-[calc(100vh-80px)] md:mt-24 md:pt-16 md:pb-24 text-white flex items-center justify-center">
      <Toaster position="top-center" reverseOrder={false} />
      <div className="backdrop-blur-md bg-white/5 border border-white/10 rounded-3xl shadow-2xl p-8 max-w-xl w-full animate-fadeIn">

        <h2 className="text-3xl font-bold mb-4 text-center bg-gradient-to-r from-cyan-400 to-indigo-400 bg-clip-text text-transparent">Contact Me</h2>
        
        <p className="text-gray-400 text-xs md:text-sm text-center mb-8">
          Have an exciting project or role? Drop a message below or{" "}
          <a
            href={process.env.REACT_APP_CALL_LINK || "#"}
            target="_blank"
            rel="noreferrer"
            className="text-cyan-400 font-semibold hover:underline animate-pulse"
          >
            schedule a call directly
          </a>.
        </p>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Name */}
          <div className="relative">
            <input
              type="text"
              id="name"
              name="name"
              required
              className="peer w-full px-4 pt-6 pb-2 bg-white/5 text-white border border-white/10 rounded-xl placeholder-transparent focus:outline-none focus:border-cyan-400 focus:bg-white/10 transition-all duration-300"
              placeholder="Name"
            />
            <label htmlFor="name" className="absolute left-4 top-2 text-xs text-gray-400 peer-placeholder-shown:top-4 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-500 transition-all">
              Name
            </label>
            <ValidationError prefix="Name" field="name" errors={state.errors} />
          </div>

          {/* Email */}
          <div className="relative">
            <input
              type="email"
              id="email"
              name="email"
              required
              className="peer w-full px-4 pt-6 pb-2 bg-white/5 text-white border border-white/10 rounded-xl placeholder-transparent focus:outline-none focus:border-cyan-400 focus:bg-white/10 transition-all duration-300"
              placeholder="Email"
            />
            <label htmlFor="email" className="absolute left-4 top-2 text-xs text-gray-400 peer-placeholder-shown:top-4 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-500 transition-all">
              Email
            </label>
            <ValidationError prefix="Email" field="email" errors={state.errors} />
          </div>

          {/* Message */}
          <div className="relative">
            <textarea
              id="message"
              name="message"
              rows="4"
              required
              placeholder="Message"
              className="peer w-full px-4 pt-6 pb-2 bg-white/5 text-white border border-white/10 rounded-xl placeholder-transparent resize-y focus:outline-none focus:border-cyan-400 focus:bg-white/10 transition-all duration-300"
            />
            <label htmlFor="message" className="absolute left-4 top-2 text-xs text-gray-400 peer-placeholder-shown:top-4 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-500 transition-all">
              Message
            </label>
            <ValidationError prefix="Message" field="message" errors={state.errors} />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={state.submitting}
            className="w-full flex items-center justify-center gap-2 bg-gradient-to-r from-cyan-500 to-indigo-500 hover:from-cyan-400 hover:to-indigo-400 transition-all duration-300 text-slate-950 font-bold px-6 py-3 rounded-xl disabled:opacity-50 cursor-pointer"
          >
            {state.submitting ? (
              <>
                <ImSpinner2 className="animate-spin" />
                Sending...
              </>
            ) : isSuccess ? (
              <>
                <FaCheckCircle className="text-slate-950" />
                Sent!
              </>
            ) : (
              "Submit"
            )}
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
